export default "__VITE_ASSET__Cud7TOmf__"